<template>
  <div class="tol-currency">
    <div class="dollar-sign">$&nbsp;</div>
    <div>
      <input
        :value="value"
        v-bind="attrs"
        class="input-field"
        type="text"
        @input="$emit('input', $event.target.value)"
        v-on="listeners"
      />
    </div>
  </div>
</template>
<script>
export default {
  name: 'InputFieldCurrency',
  inheritAttrs: false,
  props: {
    value: {
      type: [String, Boolean, Number],
      required: true
    }
  },
  computed: {
    attrs() {
      return this.$attrs;
    },
    listeners() {
      // eslint-disable-next-line no-unused-vars
      const { input, ...listeners } = this.$listeners;
      return listeners;
    }
  }
};
</script>

<style scoped lang="scss">
@import '../styles/colors.scss';

input[readonly='readonly'] {
  border: 0;
}

.tol-currency {
  display: flex;
  align-items: stretch;
}

.dollar-sign {
  align-self: center;
}

.input-field {
  border: 1px solid $input-border;
  width: 100%;
  height: 100%;
  font-size: inherit;
}
</style>
